import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=659d0ce9&scoped=true&"
import script from "./ProductDescription.vue?vue&type=script&lang=js&"
export * from "./ProductDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d0ce9",
  null
  
)

export default component.exports